import Mutations from '../../odata/mutations';

export default { ...new Mutations('twilioNumber'), ...new Mutations('twilioNumbers') };
